import React from "react"
import {useFetchToken} from "./useFetchToken";
import Loader from "../../components/loader/Loader";

interface PermissionProviderProps {
    children?: React.ReactNode
}

const AuthorizationProvider: React.FC<PermissionProviderProps> = ({children}) => {
    const {isLoading} = useFetchToken()

    if (isLoading) return <Loader/>

    return (
        <>
            {children}
        </>
    )
}

export default AuthorizationProvider
